import {Component, OnInit} from '@angular/core';

@Component({
    selector: 'asistencia-reporte-general-barra',
    standalone: false,
    template: `
        <div class="header-mainInfo">
            <h1 class="control-item">Asistencia</h1>
            <span class="header-mainInfo__separator">/</span>
            <h1 class="">General</h1>
            <span class="spacer"></span>
        </div>`
})

export class AsistenciaReporteGeneralBarraComponent implements OnInit {

    constructor() {
    }

    ngOnInit() {
    }
}